<template>
  <div>
    <v-card>
      <v-card-title>Api Key erstellen</v-card-title>
      <v-card-text>
        <v-text-field label="Owner" v-model="owner"></v-text-field>

      </v-card-text>
      <v-card-actions>
        <v-btn v-on:click="create">Schlüssel generieren</v-btn>
      </v-card-actions>
    </v-card>
    <v-data-table
    :items="keys"
    :headers="headers">
      <template v-slot:item.key="{ item }">
        {{getShortText(item.key)}}
        <v-btn icon v-on:click="copy(item.key)"><v-icon>mdi-content-copy</v-icon></v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            color="red"
            @click.stop="deleteKey(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {accountService} from "@/services/accountService";
import {apiKeyService} from "@/services/apiKeyService";

export default {
name: "ApiKeys",
  data: () => ({
    keys: "",
    headers: [
      {
        text: "Owner",
        value: "ownerName"
      },
      {
        text: "Key",
        value: "key"
      },
      {text: 'Aktionen', value: 'actions', sortable: false}
    ],
    owner: ""
  }),
  methods: {
  copy(text) {
    navigator.clipboard.writeText(text)
  },
    create() {
      let self = this;
      apiKeyService.createKey(this.owner).then(() => {
        self.owner = "";
        apiKeyService.getKeys().then(keys => {
          self.keys = keys;
        })
      })
    },
    deleteKey(key) {
      apiKeyService.deleteKey(key.key).then(() => {
        apiKeyService.getKeys().then(keys => {
          self.keys = keys;
        })
      })
    },
    getShortText(text) {
      if (text.length > 15) {
        var trimmedString = text.substr(0, 15);

        return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(""))) + "..."
      }
      return text
    },
  },
  created() {
    let self = this;
    apiKeyService.getKeys().then(keys => {
      self.keys = keys;
    }).catch((error) => {
      console.log(error);
      accountService.refreshToken().then(() => this.created()).catch(() => accountService.signOut())
    });
    document.title = "Leistungen Visieren";
    //serviceService.getQuery("confirmed=false").then(value => self.items = value);
  }
}
</script>

<style scoped>

</style>